var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.required") } },
    [
      _c(
        "span",
        { attrs: { slot: "label" }, slot: "label" },
        [
          _vm._v(_vm._s(_vm.i18nt("designer.setting.required")) + "\n    "),
          _c(
            "el-tooltip",
            {
              attrs: {
                effect: "light",
                content: "字段设计中开启必填，此字段务必必填",
              },
            },
            [_c("i", { staticClass: "el-icon-info" })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-switch", {
        model: {
          value: _vm.optionModel.required,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "required", $$v)
          },
          expression: "optionModel.required",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }